module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginbg"
  }, [_c('div', {
    staticClass: "login_logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup_center "
  }, [_c('div', {
    staticClass: "box_size"
  }, [_c('div', {
    staticClass: "login_img"
  }), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login_input"
  }, [_c('ul', [_c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    ref: "password1",
    attrs: {
      "type": "password",
      "placeholder": "输入密码"
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    ref: "password2",
    attrs: {
      "type": "password",
      "placeholder": "再一次输入密码"
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "login_bot"
  }, [_c('span', [(_vm.btnEnable) ? _c('a', {
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("激活")]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('main-modal', {
    ref: "modal1",
    attrs: {
      "size": "small",
      "title": "提示"
    }
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.tipContent)
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closetip
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('main-modal', {
    ref: "modalTimer",
    attrs: {
      "size": "small",
      "title": "提示"
    }
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.tipContent)
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user_tab",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "active",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('a', [_vm._v("账号激活")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bot_tip"
  }, [_c('span', [_c('a', [_vm._v("联系我们")]), _vm._v(" | "), _c('a', [_vm._v("法律声明")]), _vm._v(" | "), _c('a', [_vm._v("下载中心")]), _vm._v(" | "), _c('a', [_vm._v("网站地图")])]), _vm._v(" "), _c('em', [_vm._v("©2017 青岛迪迪网络科技有限公司 All Rights Reserved.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d3ad6f2","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/login/Activation.vue
// module id = 1410
// module chunks = 0